import axios from "axios";
import { isAuthenticated } from "../../../../commons/Auth/auth";

export {
  listAccounts,
  createAccount,
  updateAccount,
  accountSheet,
  listEntries,
  createEntry,
  getEntry,
  updateEntry,
  reverseEntry,
  listPeriods,
  closePeriod,
  reopenPeriod,
  trialBalance,
  auditTrail,
  errorText
} from "../api";

/**
 * Projects double as cost centres on a booking line. The app has no dedicated lightweight
 * list, so the existing paginated endpoint is asked for everything of this tenant.
 */
export const listProjects = async () => {
  const auth = isAuthenticated();
  const serviceProvider = auth?.employer?._id || auth?._id;
  const res = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/projects/limited`,
    { pageSize: 100000, pageNo: 0, serviceProvider },
    { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
  );
  return Array.isArray(res.data?.data) ? res.data.data : [];
};
